import React from 'react';
import { useTranslation } from '../lib/i18n';
import { motion } from 'framer-motion';
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useTranslation();
  return <div className="fixed top-4 right-4 z-50 bg-white/80 backdrop-blur-md rounded-full p-1 shadow-lg border border-white/20 flex items-center" data-id="element-129">
      <button onClick={() => setLang('de')} className={`relative px-3 py-1 rounded-full text-xs font-bold transition-colors duration-300 ${lang === 'de' ? 'text-white' : 'text-text-secondary hover:text-hotpink'}`} data-id="element-130">
        {lang === 'de' && <motion.div layoutId="activeLang" className="absolute inset-0 bg-hotpink rounded-full shadow-sm" transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} data-id="element-131" />}
        <span className="relative z-10" data-id="element-132">DE</span>
      </button>
      <button onClick={() => setLang('en')} className={`relative px-3 py-1 rounded-full text-xs font-bold transition-colors duration-300 ${lang === 'en' ? 'text-white' : 'text-text-secondary hover:text-hotpink'}`} data-id="element-133">
        {lang === 'en' && <motion.div layoutId="activeLang" className="absolute inset-0 bg-hotpink rounded-full shadow-sm" transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} data-id="element-134" />}
        <span className="relative z-10" data-id="element-135">EN</span>
      </button>
    </div>;
}